var SupportGetawaysVoucherStatusAndNotesPresentation;

SupportGetawaysVoucherStatusAndNotesPresentation = {
  editable: {
    status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>",
    notes: "You can edit this order until <span class='longlocaltime'>{{editable_deadline}}</span>. " + I18n.translate('js.modules.notes.editable_notes_message')
  },
  not_editable: {
    redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    },
    purchased: {
      status: "Processing",
      notes: ""
    },
    available: {
      status: "Ready to print",
      notes: I18n.translate('js.modules.notes.not_editable_notes_message')
    },
    expired: {
      status: "Expired",
      notes: ""
    },
    expired_unredeemed: {
      status: "Promotional value expired on <span class='utctime'>{{expiration_date}}</span>",
      notes: I18n.translate('js.modules.notes.not_editable_expired_unredeemed_message') + ", you can still redeem it at <strong>{{merchant_name}}</strong> for the amount you paid for it."
    },
    expired_redeemed: {
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>",
      notes: ""
    }
  }
};

module.exports = SupportGetawaysVoucherStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c192b3VjaGVyX21lc3NhZ2VzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvZ2V0YXdheXNfdm91Y2hlcl9tZXNzYWdlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxnREFBQSxHQUNFO0VBQUEsUUFBQSxFQUNFO0lBQUEsTUFBQSxFQUFRLDBFQUFSO0lBQ0EsS0FBQSxFQUFPLDBGQUFBLEdBQTZGLElBQUksQ0FBQyxTQUFMLENBQWUseUNBQWYsQ0FEcEc7R0FERjtFQUdBLFlBQUEsRUFDRTtJQUFBLFFBQUEsRUFDRTtNQUFBLE1BQUEsRUFBTywwREFBUDtNQUNBLEtBQUEsRUFBTyxFQURQO0tBREY7SUFHQSxTQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsWUFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBSkY7SUFNQSxTQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsZ0JBQVI7TUFDQSxLQUFBLEVBQU8sSUFBSSxDQUFDLFNBQUwsQ0FBZSw2Q0FBZixDQURQO0tBUEY7SUFTQSxPQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsU0FBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBVkY7SUFZQSxrQkFBQSxFQUNFO01BQUEsTUFBQSxFQUFRLCtFQUFSO01BQ0EsS0FBQSxFQUFPLElBQUksQ0FBQyxTQUFMLENBQWUsMERBQWYsQ0FBQSxHQUE2RSxpR0FEcEY7S0FiRjtJQWVBLGdCQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsMERBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQWhCRjtHQUpGOzs7QUF1QkYsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
